import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { RmsAccessService } from '../../projects/rms/app/shared/core-rms/rms-access.service';
import { NdmsRouteResolverGuard } from '../../projects/shared/core/services/ndms-route-resolver.guard';
import {NdmsAuthenticationGuard} from "./shared/core-ndms/services/ndms-authentication.guard";
import {RmsAppModuleShared} from "../../projects/rms/app/app.module.shared";
import {JpatsAppModuleShared} from "../../projects/jpats/app/app.module.shared";
import {HirAppModuleShared} from "../../projects/hir/app/app.module.shared";
import {UsersHomeComponent} from "./components/users/users-home/users-home.component";
import { AppSelectComponent } from './components/app-select/app-select.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    resolve: {
      NdmsAuthenticationGuard,
    },
    children:[
      { path: 'rms', loadChildren: '../../projects/rms/app/app.module.shared#RmsAppModuleShared' },
      { path: 'jpats', loadChildren: '../../projects/jpats/app/app.module.shared#JpatsAppModuleShared'  },
      { path: 'hir', loadChildren: '../../projects/hir/app/app.module.shared#HirAppModuleShared' },
      { path: 'unauthorized', component: HomeComponent }
    ]
  },
  { 
    path:"app-select", 
    component:AppSelectComponent,
    canActivateChild: [NdmsAuthenticationGuard]
  },
  { 
    path:"users-home", 
    component: UsersHomeComponent,
    canActivateChild: [NdmsAuthenticationGuard],
    resolve: {
      response: NdmsRouteResolverGuard
    },
    data: {
      service: RmsAccessService,
      breadcrumbs: 'Users'
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    RmsAppModuleShared.forRoot(),
    JpatsAppModuleShared.forRoot(),
    HirAppModuleShared.forRoot(),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
